import React, { useState } from "react";
import { PencilSimple, Trash, Check, X as XIcon } from "@phosphor-icons/react";

/**
 * Compact Edit/Delete action buttons with confirmation dialog for delete.
 *
 * Props:
 *   onEdit      : () => void — opens caller-controlled edit UI
 *   onDelete    : () => Promise<any>
 *   confirmText : string     — confirmation message (default: "Hapus data ini?")
 *   testid      : string     — data-testid prefix (default: "row-actions")
 *   canEdit     : boolean    — show edit btn (default true)
 *   canDelete   : boolean    — show delete btn (default true)
 */
export default function RowActions({ onEdit, onDelete, confirmText = "Hapus data ini?", testid = "row-actions", canEdit = true, canDelete = true }) {
  const [confirming, setConfirming] = useState(false);
  const [loading, setLoading] = useState(false);

  const doDelete = async () => {
    setLoading(true);
    try { await onDelete(); } finally { setLoading(false); setConfirming(false); }
  };

  if (confirming) {
    return (
      <div className="inline-flex items-center gap-1" data-testid={`${testid}-confirm`}>
        <span className="text-xs text-red-700 mr-1">{confirmText}</span>
        <button onClick={doDelete} disabled={loading}
          className="p-1 rounded bg-red-600 text-white hover:bg-red-700 disabled:opacity-60"
          data-testid={`${testid}-confirm-yes`} title="Ya, hapus">
          <Check size={13} />
        </button>
        <button onClick={() => setConfirming(false)}
          className="p-1 rounded bg-slate-100 text-slate-700 hover:bg-slate-200"
          data-testid={`${testid}-confirm-no`} title="Batal">
          <XIcon size={13} />
        </button>
      </div>
    );
  }

  return (
    <div className="inline-flex items-center gap-1">
      {canEdit && onEdit && (
        <button onClick={onEdit} className="p-1.5 rounded text-slate-600 hover:bg-slate-100 hover:text-[#14532d]" data-testid={`${testid}-edit`} title="Edit">
          <PencilSimple size={14} />
        </button>
      )}
      {canDelete && onDelete && (
        <button onClick={() => setConfirming(true)} className="p-1.5 rounded text-slate-600 hover:bg-red-50 hover:text-red-700" data-testid={`${testid}-delete`} title="Hapus">
          <Trash size={14} />
        </button>
      )}
    </div>
  );
}
